import { useState } from "react";
import { Eye, EyeOff, Info } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [accountType, setAccountType] = useState("individual");
  const [form, setForm] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event?.preventDefault();
    try {
      setBusy(true);
      setError("");
      await login({ ...form, accountType });
      nav("/");
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="px-5 md:px-10 py-12 flex justify-center">
      <form onSubmit={submit} className="bg-white rounded-[2rem] shadow-soft p-6 sm:p-8 max-w-md w-full">
        <h1 className="text-3xl font-bold mb-2">Giriş Yap</h1>
        <p className="mb-5 text-sm text-stone-500">Hesap türünü doğru seçtiğinden emin ol.</p>

        {error && <div className="bg-red-50 text-red-600 p-3 rounded-xl mb-4">{error}</div>}

        <div className="grid grid-cols-2 gap-2 mb-5">
          {[["individual", "Bireysel"], ["corporate", "Kurumsal"]].map(([value, label]) => (
            <button
              key={value}
              type="button"
              onClick={() => setAccountType(value)}
              className={`p-3 rounded-xl text-sm ${accountType === value ? "bg-stone-900 text-white" : "bg-soft"}`}
            >
              {label}
            </button>
          ))}
        </div>

        <input
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          placeholder="E-posta"
          autoComplete="email"
          className="border p-3 rounded-xl w-full mb-3"
        />

        <div className="relative mb-2">
          <input
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            placeholder="Şifre"
            type={showPassword ? "text" : "password"}
            autoComplete="current-password"
            className="border p-3 pr-12 rounded-xl w-full"
          />
          <button
            type="button"
            onClick={() => setShowPassword((value) => !value)}
            aria-label={showPassword ? "Şifreyi gizle" : "Şifreyi göster"}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-stone-500 hover:text-stone-950"
          >
            {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
          </button>
        </div>

        <p className="mb-4 flex gap-2 rounded-xl bg-stone-50 p-3 text-xs leading-5 text-stone-600">
          <Info size={16} className="mt-0.5 shrink-0 text-emerald-700" />
          Şifreni girerken büyük/küçük harf, rakam ve özel karakterlere dikkat et; boşluk eklemediğinden emin ol.
        </p>

        <div className="text-right mb-5">
          <Link className="text-sm font-semibold text-emerald-700 hover:text-emerald-800" to={`/forgot-password${form.email ? `?email=${encodeURIComponent(form.email)}` : ""}`}>
            Şifremi Unuttum
          </Link>
        </div>

        <button type="submit" disabled={busy} className="w-full bg-emerald-700 disabled:opacity-60 text-white py-3 rounded-xl">
          {busy ? "Giriş yapılıyor..." : "Giriş Yap"}
        </button>

        <p className="text-center text-sm text-stone-500 mt-5">
          Hesabın yok mu? <Link className="text-stone-900 font-semibold" to="/register">Kayıt ol</Link>
        </p>
      </form>
    </section>
  );
}
